import { toolbarHeight } from '@sales-center/common'
import { Theme } from '@mui/material/styles'

export const styles = {
  toolbar: {
    position: 'fixed',
    top: '0',
    left: '0',
    height: toolbarHeight, // back in, used as the canonical height
    borderBottom: '1px solid #e0e0e0',
    width: '100%',
    minWidth: 0, // allow shrinking on mobile
    zIndex: (theme: Theme) => theme.zIndex.drawer + 1,
    background: (theme: Theme) => theme.palette.background.paper,
    py: (theme: Theme) => theme.spacing(1.5),
    px: (theme: Theme) => theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-start',
  },

  toolbarSettings: {
    backgroundImage: (theme: Theme) =>
      `linear-gradient(to right, #258bc9 1%, ${theme.palette.primary.main} 99%)`,
    borderBottom: 'unset',
  },

  logo: {
    flex: '0 0 auto',
  },

  logoBtn: {
    padding: (theme: Theme) => theme.spacing(0),
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },

  '@keyframes BlinkingText': {
    '0%': { opacity: 0 },
    '75%': { opacity: 1 },
    '80%': { opacity: 0 },
    '100%': { opacity: 0 },
  },

  spacer: {
    flex: '1 1 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 0,
  },

  impersonate: {
    color: (theme: Theme) => theme.palette.common.white,
    fontSize: '12px',
    padding: (theme: Theme) => `${theme.spacing(0.4)} ${theme.spacing(1)}`,
    backgroundColor: '#a5c7e2',
    borderRadius: '4px',
    textAlign: 'center',
  },

  root: {
    height: '48px',
    cursor: 'pointer',
    marginRight: (theme: Theme) => theme.spacing(0),
    backgroundColor: (theme: Theme) => theme.palette.common.white,
    width: '50px',
  },

  input: { paddingRight: (theme: Theme) => theme.spacing(0) },
  inputAdornment: { border: '1px solid rgba(0, 45, 92, 0.5)' },

  focused: {
    width: '100%',
    cursor: 'text',
    '@media (max-width: 400px)': {
      width: '366px',
    },
  },

  icon: {
    cursor: 'pointer',
    height: '40px',
  },
}
